module.exports = __webpack_public_path__ + "static/media/Sangath.114fd8c6.svg";